import jwtDecode from "jwt-decode";
import R from "ramda";
import moment from "moment";

import {
	accountURL,
	scapholdAuthTokenStorageKey,
} from "./consts";

const jwtDecodeMemo = R.memoize(jwtDecode);

const keyInDate = key =>(
	moment.unix(jwtDecodeMemo(key).exp).isAfter(moment())
);

const getJWTFromIFrame = () => {
	let iFrame = document.getElementById("account-iframe");

	const responsePromise = new Promise(done =>
		//handle response from account.codogo.io
		window.addEventListener(
			"message",
			event => {
				if (event.origin !== accountURL) {
					return;
				}

				if (event.data.jwt && keyInDate(event.data.jwt)) {
					localStorage.setItem(
						scapholdAuthTokenStorageKey,
						event.data.jwt,
					);

					iFrame.remove();

					done(event.data.jwt);
				} else {
					window.location =
						accountURL + 
						"/app/login?come_from=" +
						window.location;
				}
			},
			false,
		),
	);

	try{
		iFrame.contentWindow.postMessage(
			"REQUEST_SCAPHOLD_JWT",
			accountURL,
		);
	}
	catch(e){
		//get auth details, tempoary, move to shell at some point
		iFrame = document.createElement("iframe");
		iFrame.src = accountURL;
		iFrame.style.display = "none";

		iFrame.onload = function() {
			iFrame.contentWindow.postMessage(
				"REQUEST_SCAPHOLD_JWT",
				accountURL,
			);
		};

		document.body.appendChild(iFrame);
	}

	return responsePromise;
};

//if key is in localstorage and is valid, return the key
//if it is not, try to get it from and iframe to account.codogo.io
//if the key got from the iframe still isn't valid, redirect to account.codogo.io to refresh, then come back here and try again

export default () =>
	Promise.resolve(
		localStorage.getItem(scapholdAuthTokenStorageKey),
	).then(
		(key) => (
			key && keyInDate(key) ? key : getJWTFromIFrame()
		)
	);

